<template>
  <div class="card radius-10 ma-20">
    <div class="card-content pa-20">
      <figure class="image is-96x96 mx-auto">
        <img src="@/assets/images/icon_modal/icon_refu.png">
      </figure>
    </div>
    <div class="card-content pa-20 has-text-centered" v-if="isNoReject">
      <h4 class="has-text-weight-bold is-size-4">Refuser la proposition</h4>
      <p class="is-size-14px">Êtes-vous sûr de vouloir refuser la proposition?</p>
      <div class="mt-20">
        <b-button
          class="box-shadow-0"
          type="is-primary"
          expanded
          rounded
          @click="refusMail">
          Refuser la proposition
        </b-button>
      </div>
      <div class="mt-20">
        <b-button
          class="box-shadow-0"
          expanded
          rounded
          @click="$emit('modif')">
          Demander des modifications
        </b-button>
      </div>
      <div class="mt-20">
        <b-button
          class="box-shadow-0"
          expanded
          rounded
          @click="$emit('close')">
          Retour
        </b-button>
      </div>
    </div>
    <div class="card-content pa-20 has-text-centered" v-else>
      <h4 class="has-text-weight-bold is-size-4">Proposition refusée</h4>
      <p class="is-size-14px">Nous avons informé le commercial de votre décision.</p>
      <div class="mt-20">
        <b-button
          class="box-shadow-0 mr-10"
          type="is-primary"
          rounded
          @click="$emit('close')">
          Fermer
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { sendRefusEmail } from '@/services/mail/sendEmail';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  data: () => ({
    isNoReject: true,
  }),
  computed: {
    ...Recommandation.mapGetters({
      getCommercial: 'commercial',
      getClient: 'pdv',
      getRecom: 'recom',
    }),
  },
  methods: {
    refusMail() {
      const commercial = this.getCommercial.prenom ? `${this.getCommercial.prenom},<br>` : '';
      const email = this.getCommercial.email ? this.getCommercial.email : '';
      sendRefusEmail(this.$route.params.id, commercial, this.getClient.libelle, '', this.getRecom.themeCampagne, email);
      this.isNoReject = false;
    },
  }
}
</script>

<style>
</style>